export const cssStyle = (vars: Record<string, string | number | boolean>, prefix = ''): string => {
	return Object.entries(vars)
		.map(([k, v]) => `${prefix}${k}:${v as string}`)
		.join(';');
};
export const cssVars = (vars: Record<string, string | number | boolean>): string =>
	cssStyle(vars, '--');
